module.exports = __webpack_public_path__ + "static/media/quiz-hint-2-en-1080p.ae687783.mp4";